import React, {useMemo} from "react";
import axios from "../../../../util/axios";




const equisDetail = (props, _ref) => {

    const {onShow,equisDetailData,RevInfo,PDFDownFunction,btnState,HandleUploadConfrim} = props;


    // eslint-disable-next-line react-hooks/rules-of-hooks
    const disabledFun = useMemo(() => {

        return equisDetailData?.status__v ==="Draft" ||
            equisDetailData?.status__v ==="Effective" ||
            equisDetailData?.status__v ==="Withdrawn"
    },[equisDetailData])

    return (
        <>
            <div className={"text-right"}>
                <button className={"bpl-btn main"} onClick={onShow}>Change</button>
            </div>
            <table className={"bpl-table-default"}>
                <tbody>
                <tr>
                    <th>DOC Id.</th>
                    <td>{equisDetailData?.id}</td>
                </tr>
                <tr>
                    <th>DOC No.</th>
                    <td>{equisDetailData?.document_number__v}</td>
                </tr>
                <tr>
                    <th>Name</th>
                    <td>{equisDetailData?.name__v}</td>
                </tr>
                </tbody>
            </table>
            <div className={"uploadBtnBox"}>
                <button className={"bpl-btn danger "} disabled={!disabledFun} onClick={() => HandleUploadConfrim()}>{disabledFun ? "UPLOAD":"The document is not appropriate state for update. Please check in EQUIS."}</button>
            </div>
        </>
    )
}

export default React.memo(equisDetail);